import {setOtpDashboardData} from '../slice/otpSlice';
import {baseQueryWithReAuth} from './config';
import {OtpDashboardData} from '@/types/otp';
import {transformAirline} from '@/utils/flight';
import {createApi} from '@reduxjs/toolkit/query/react';

export const otpApi = createApi({
  reducerPath: 'otpApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['otp-dashboard'],
  endpoints: (builder) => ({
    getOtpDashboard: builder.query<
      OtpDashboardData[],
      {airline: string; range: string}
    >({
      providesTags: () => ['otp-dashboard'],
      query: ({airline, range}) => ({
        url: '/ATLAS_otp__get_dashboard_data',
        method: 'POST',
        body: {
          airline: transformAirline(airline),
          range
        }
      }),
      async onQueryStarted(_args, {dispatch, queryFulfilled}) {
        try {
          const data = await queryFulfilled;
          if (data) {
            dispatch(setOtpDashboardData(data.data));
          }
        } catch (error) {
          throw new Error('Error getOtpDashboard');
        }
      }
    })
  })
});

export const {useGetOtpDashboardQuery, useLazyGetOtpDashboardQuery} = otpApi;
